/**
 * Initializes the carousel progress bar (track + bar) for a given carousel element.
 * Only inits elements that have .carousel-progress as a direct child (the snippet root).
 * @param {HTMLElement} carousel - Element with class .resource-list__carousel
 */
function initCarouselProgress(carousel) {
  if (carousel.dataset.carouselProgressInit === 'true') return;
  if (!carousel.querySelector(':scope > .carousel-progress')) return;
  const scroller = carousel.querySelector('slideshow-slides');
  const track = carousel.querySelector('.carousel-progress__track');
  const bar = carousel.querySelector('.carousel-progress__bar');
  if (!scroller || !track || !bar) return;

  carousel.dataset.carouselProgressInit = 'true';

  const update = () => {
    const { scrollLeft, scrollWidth, clientWidth } = scroller;
    if (scrollWidth <= clientWidth) {
      bar.style.width = '100%';
      bar.style.left = '0';
      return;
    }
    const thumbRatio = clientWidth / scrollWidth;
    const thumbWidth = Math.max(thumbRatio * 100, 10);
    const maxLeft = 100 - thumbWidth;
    const scrollRatio = scrollLeft / (scrollWidth - clientWidth);
    const left = scrollRatio * maxLeft;
    bar.style.width = thumbWidth + '%';
    bar.style.left = left + '%';
  };

  const trackToScroll = (clientX) => {
    const rect = track.getBoundingClientRect();
    const x = clientX - rect.left;
    const ratio = Math.max(0, Math.min(1, x / rect.width));
    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    return ratio * maxScroll;
  };

  track.addEventListener('click', (e) => {
    if (e.target === bar) return;
    scroller.scrollLeft = trackToScroll(e.clientX);
  });

  let dragging = false;
  const onMove = (e) => {
    if (!dragging) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    scroller.scrollLeft = trackToScroll(clientX);
  };
  const onEnd = () => {
    dragging = false;
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onEnd);
    document.removeEventListener('touchmove', onMove, { passive: false });
    document.removeEventListener('touchend', onEnd);
  };

  bar.addEventListener('mousedown', (e) => {
    e.preventDefault();
    dragging = true;
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);
  });
  bar.addEventListener('touchstart', () => {
    dragging = true;
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
  }, { passive: true });

  scroller.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(scroller);
  update();
}

function runCarouselProgressInit() {
  document.querySelectorAll('.resource-list__carousel').forEach(initCarouselProgress);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runCarouselProgressInit);
} else {
  runCarouselProgressInit();
}

const carouselProgressObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length === 0) continue;
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1 || !node.querySelectorAll) return;
      let carousels = Array.from(node.querySelectorAll('.resource-list__carousel')).filter(
        (el) => el.querySelector(':scope > .carousel-progress')
      );
      if (node.classList?.contains('resource-list__carousel') && node.querySelector?.(':scope > .carousel-progress')) {
        carousels = [node, ...carousels];
      }
      carousels.forEach((el) => setTimeout(() => initCarouselProgress(el), 0));
    });
  }
});
carouselProgressObserver.observe(document.body, { childList: true, subtree: true });
